import React from "react";
import Chart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

export default function ApexSalesChart({ data }) {
    const theme = useTheme();

    const chartData = React.useMemo(() => (Array.isArray(data) && data.length > 0
        ? data.map(item => ({
            x: new Date(item.date).toLocaleDateString('en-US', { weekday: 'short' }),
            y: parseFloat(item.total || item.amount || 0)
        }))
        : Array.from({ length: 7 }, (_, i) => ({
            x: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][i],
            y: Math.floor(Math.random() * 2000) + 500
        }))), [data]);

    const options = React.useMemo(() => ({
        chart: {
            id: "dashboard-sales-trend",
            type: "area",
            toolbar: { show: false },
            zoom: { enabled: false },
            sparkline: { enabled: false },
            fontFamily: "inherit"
        },
        dataLabels: { enabled: false },
        stroke: {
            curve: "smooth",
            width: 3,
            colors: [theme.palette.primary.main]
        },
        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.45,
                opacityTo: 0.05,
                stops: [20, 100, 100],
                colorStops: [
                    {
                        offset: 0,
                        color: theme.palette.primary.main,
                        opacity: 0.4
                    },
                    {
                        offset: 100,
                        color: theme.palette.primary.main,
                        opacity: 0
                    }
                ]
            }
        },
        grid: {
            show: true,
            borderColor: theme.palette.divider,
            strokeDashArray: 4,
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } },
            padding: { top: 0, right: 0, bottom: 0, left: 10 }
        },
        xaxis: {
            categories: chartData.map(item => item.x),
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: {
                style: {
                    colors: theme.palette.text.secondary,
                    fontSize: "12px"
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: theme.palette.text.secondary,
                    fontSize: "12px"
                },
                formatter: (val) => `$${val.toLocaleString()}`
            }
        },
        tooltip: {
            theme: theme.palette.mode,
            x: { show: true },
            y: {
                formatter: (val) => `$${val.toFixed(2)}`,
                title: { formatter: () => "Revenue: " }
            }
        },
        legend: {
            onItemClick: { toggleDataSeries: false } // ✅ FIX: Prevents crash on legend click
        },
        colors: [theme.palette.primary.main]
    }), [theme.palette.primary.main, theme.palette.divider, theme.palette.text.secondary, theme.palette.mode, chartData]);

    const series = React.useMemo(() => [{
        name: "Sales",
        data: chartData.map(item => item.y)
    }], [chartData]);

    return (
        <div className="apex-chart-wrapper" style={{ width: '100%', height: '100%' }}>
            <Chart options={options} series={series} type="area" height="100%" />
        </div>
    );
}
